<template>
  <label class="field-block" :class="{ 'field-panel': panel }">
    <span>{{ label }}</span>
    <div v-if="loading" class="field-loading">
      <spinner size="small" color-scheme="dark" />
    </div>
    <select v-else v-model="selectedStageId" :disabled="disabled">
      <option :value="null">-</option>
      <option v-for="stage in stages" :key="stage.id" :value="stage.id">
        {{ stageOptionLabel(stage) }}
      </option>
    </select>
  </label>
</template>

<script>
import Spinner from 'shared/components/Spinner';

export default {
  name: 'OpportunityStageSelect',
  components: {
    Spinner,
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    stages: {
      type: Array,
      default: () => [],
    },
    currentStageId: {
      type: [Number, String],
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    panel: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedStageId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    stageIndex(stage) {
      return this.stages.findIndex(
        item => Number(item.id) === Number(stage.id)
      );
    },
    isCurrentStage(stage) {
      return Number(stage.id) === Number(this.currentStageId);
    },
    currentStageIndex() {
      const index = this.stages.findIndex(item => this.isCurrentStage(item));
      return index >= 0 ? index : 0;
    },
    isActiveStage(stage) {
      const current = this.currentStageIndex();
      const index = this.stageIndex(stage);
      return current >= 0 && index === current;
    },
    isCompletedByIndex(stage) {
      const current = this.currentStageIndex();
      const index = this.stageIndex(stage);
      return current >= 0 && index >= 0 && index < current;
    },
    stageOptionLabel(stage) {
      if (this.isActiveStage(stage)) {
        return `🟢 ${stage.name}`;
      }

      if (this.isCompletedByIndex(stage)) {
        return `🔵 ${stage.name}`;
      }

      return `⚪ ${stage.name}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.field-panel {
  background: var(--s-50);
  border-radius: var(--border-radius-small);
  padding: var(--space-small);
}

.field-block {
  display: flex;
  flex-direction: column;
  gap: var(--space-micro);
  margin-top: var(--space-small);
}

.field-loading {
  align-items: center;
  background: var(--white);
  border: 1px solid var(--s-100);
  border-radius: var(--border-radius-small);
  display: flex;
  height: 4rem;
  justify-content: center;
  margin-bottom: var(--space-normal);
}

.field-block select {
  border: 1px solid var(--s-100);
  border-radius: var(--border-radius-small);
  padding: var(--space-smaller);
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 8'%3E%3Cpath fill='%23111827' d='M6 8L0 0h12z'/%3E%3C/svg%3E");
  background-position: right 0.9rem center;
  background-repeat: no-repeat;
  background-size: 0.75rem;
  padding-right: 2.2rem;
}
</style>
